import { Tooltip } from 'primereact/tooltip';
import React from 'react';

import IconProvider from '../../../utils/IconProvider';
import './MoodImageCard.css';

type MoodImageCardProps = {
    icon: string;
    tooltip: string;
    moodType: string;
    onClick: (moodType: string) => void;
};

const MoodImageCard = ({ icon, tooltip, moodType, onClick }: MoodImageCardProps) => {
    const handleSubmitMoodMeter = (moodType: string) => {
        onClick(moodType);
    };
    return (
        <div className="mood-image-card">
            <button
                className={`mood-image-card-btn  ${moodType.toLowerCase()}`}
                aria-label={tooltip}
                data-testid={moodType.toLowerCase()}
                onClick={() => handleSubmitMoodMeter(moodType)}
            >
                <IconProvider acrn={icon} iconHeight="59px" />
                <Tooltip
                    target={`.${moodType.toLowerCase()}`}
                    content={tooltip}
                    className="icon-tooltip"
                    position="right"
                />
            </button>
        </div>
    );
};

export default MoodImageCard;
